module.exports = __webpack_public_path__ + "static/media/ritualbanners.6ad6b3a8.png";